import React, { ReactNode } from 'react';
import { Box, BoxProps, Text } from '@razorpay/blade/components';

export const ComponentHeader = ({
  title,
  icon,
  iconBackground,
}: {
  title: string;
  icon: ReactNode;
  iconBackground: BoxProps['backgroundColor'];
}) => {
  return (
    <Box display={'flex'} flexDirection={'row'} gap={'spacing.4'} alignItems={'center'}>
      <Box
        minWidth="36px"
        minHeight="36px"
        maxWidth="36px"
        maxHeight="36px"
        borderRadius={'round'}
        backgroundColor={iconBackground}
        display="flex"
        alignItems="center"
        justifyContent="center">
        {icon}
      </Box>

      <Box display={'flex'} flexDirection={'row'} gap={'spacing.3'}>
        <Text size="medium" weight="semibold">
          {title}
        </Text>
      </Box>
    </Box>
  );
};
